import { Browser } from "@capacitor/browser";
import { useRouter } from "@tanstack/react-router";
import { Button } from "@/components/button";
import { trackEvent } from "@/lib/tracking";

export const AssistProAcceptanceFooterButton = (): JSX.Element => {
  const router = useRouter();

  const handleTermsClick = async (): Promise<void> => {
    await Browser.open({
      url: "https://ajuda.livance.com.br/hc/pt-br/articles/39398692911763-Termos-de-Uso-Livance-Assist-Pro",
    });
  };

  const handleButtonClick = (): void => {
    trackEvent("Botão Permanecer Assist Pro Clicado");
    void router.navigate({
      search: { action: "open-confirm-assist-pro-drawer" },
      replace: true,
    });
  };

  return (
    <>
      <div className="h-[152px] w-full shrink-0" />

      <div className="flex flex-col gap-2 fixed bottom-0 left-0 right-0 bg-neutral-50 p-4 z-50 border-t border-neutral-100">
        <Button className="font-medium" fullWidth onClick={handleButtonClick}>
          Permanecer no Assist Pro
        </Button>
        <p className="text-sm text-neutral-500 text-center px-6">
          Ao continuar você está concordando com nossos{" "}
          <button
            type="button"
            onClick={() => void handleTermsClick()}
            className="underline"
          >
            Termos de uso
          </button>
          .
        </p>
      </div>
    </>
  );
};
